import clsx from "clsx";
import Background, { type BackgroundProps } from "@react/widget/Background";
export { type BackgroundProps } from "@react/widget/Background";
import Border, { type BorderType } from '@module/border';

const bgColors = {
  "none": "",
  "transparent": "bg-transparent",
	"white": "bg-white",
	"gray": "bg-gray-50",
  "gray-md": "bg-gray-60",
  "gray-dark": "bg-gray-dark text-white",
  "borderTop": "border-t",
  "gray-white": "bg-white md:bg-gray-50",
  "gray-products": "bg-gray-products md:bg-transparent",
};

export type BGColors = keyof typeof bgColors;

export interface Props extends Record<string, any> {
  class?: string;
  py?: string;
  pt?: string;
  pb?: string;
  px?: string;
  pl?: string;
  pr?: string;
  postion?: string;
  sectionClass?: string;
  containerClass?: string;
  border?: Array<BorderType>;
  background?: BackgroundProps;
}

const Section:React.FC<Props> = ({ class: className, py = "py-12 lg:py-24", pt, pb, px = "", pl, pr, sectionClass, containerClass = "", postion = "relative", border, background = {color: "none"}, before, children, after, ...props }) => {
  const bg = background ? Object.assign({inner: false, color: "none", position: "absolute"}, background) : undefined;
  // border
  const bd = Border.parser(border);
  // background
  if(bg) bg.color = Object.keys(bgColors).includes(bg.color) ? bgColors[bg.color as BGColors] : bg.color;
  const bgInner = (bg && bg.inner) ? true : false;
  const paddingY = (!pt && !pb) ? py : clsx(pt ?? "pt-12 lg:pt-24", pb ?? "pb-12 lg:pb-24");
  const paddingX = (!pl && !pr) ? px : clsx(pl ?? "", pr ?? "");

  return (
  <section className={clsx((!bgInner && !bd.top) && paddingY, sectionClass, !bgInner && postion, className)} {...props}>
    {before}
    <div className={clsx("container mx-auto", (bgInner || bd.top) && paddingY, paddingX, containerClass, bgInner && postion, bd.class)}>
      { (bg && bg.inner) && <Background data={bg}/> }
      {children}
    </div>
    {after}
    { (bg && !bg.inner) && <Background data={bg}/> }
  </section>
  );
};

export default Section;